<template><rgbw-control-editor :objData="objData" realtime /></template>
<script>
import RgbwControlEditor from "components/content/control-toast/rgbw-control-editor";
export default { props: { objData: Object }, components: { RgbwControlEditor } };
</script>
